import {action} from 'mobx';
import {DomainStore} from 'shared/store';

class MyExpensesState {
  store = new DomainStore();
  history;

  receiveProps({history}) {
    this.history = history;
  }

  @action goToNewExpense() {
    this.history.push('/expense_requests/new');
  }

  @action async removeExpenseRequest(request) {
    await this.store.destroy(request);
  }
}

export default MyExpensesState;
